'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function PLFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("mask", { id: "mantine-lqzbnhx49", fill: "#fff" }, /* @__PURE__ */ React.createElement("rect", { width: "32", height: "24", fillRule: "evenodd", rx: "2" })), /* @__PURE__ */ React.createElement("mask", { id: "mantine-y6pwnjndv", fill: "#fff" }, /* @__PURE__ */ React.createElement("use", { fillRule: "evenodd", xlinkHref: "#mantine-15lwj4e9w" })), /* @__PURE__ */ React.createElement("path", { id: "mantine-15lwj4e9w", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-lqzbnhx49)" }, /* @__PURE__ */ React.createElement("use", { fill: "#f7fcff", xlinkHref: "#mantine-15lwj4e9w" }), /* @__PURE__ */ React.createElement("path", { fill: "#c51918", d: "M0 12h32v12H0z", mask: "url(#mantine-y6pwnjndv)" })))
  );
}

export { PLFlag };
//# sourceMappingURL=PL.mjs.map
